import { FigureUltimateStatus } from "../../../enums/FigureUltimateStatus";
import { ISquareModel } from "../../square/ISquareModel";
import { FigureData } from "../FigureData";
import { IFigureModel } from "../IFigureModel";

export class FigureModel implements IFigureModel {    
    public constructor(
        private readonly figureData: FigureData,
        private readonly shape: Array<ISquareModel> | ISquareModel,
        private readonly ultimateStatus: FigureUltimateStatus
    ) { }

    public get FigureData(): FigureData {
        return this.figureData;
    }
    public get Shape(): Array<ISquareModel> | ISquareModel {
        return this.shape;
    }
    public get isUltimate(): boolean {
        return this.ultimateStatus == FigureUltimateStatus.ULTIMATE;
    }
}